import React, { Component } from 'react';

class Element extends Component {

  dataTypeToText = {
    'date': 'date',
    'integer': 'number',
    'double': 'number'
  };

  componentDidMount() {
    // fill required selects with no valid value
    // with first valid value
    const struct = this.getSubStructure(this.props.structure, this.props.path);
    const childrenCheck = this.checkChildren(struct);
    const children = this.getChildren(struct);
    const value = this.getValue() || '';

    const isSelect = childrenCheck === 'select';

    if (!struct.optional && isSelect && children.length && !children.find(e => e.value == value)) {
      this.setValue(children[0].value);
    }
  }

  getPathChain(path) {
    return path.replace(/></g, '-').replace(/>/g, '').replace(/</g, '').split('-');
  }

  getSubStructure(structure, path) {
    const pathChain = this.getPathChain(path);

    return pathChain.reduce((s, part) => {
      const child = s.children.find(c => c.name === part);

      if (!child && part === 'gavedoc') return s.children[0];

      return child;
    }, structure);
  }

  getLabel(path, el) {
    const field = this.getNamesEntry(path, el);
    return field && field.label ? field.label : field;
  }

  getDescription(path, el) {
    const field = this.getNamesEntry(path, el);
    return field && field.description ? field.description : field;
  }

  getUnit(path, el) {
    const field = this.getNamesEntry(path, el);

    return field && field.unit ? field.unit : false;
  }

  getNamesEntry(path, el) {
    const pathChain = this.getPathChain(path);
    if (el !== null && el !== undefined) {
      pathChain.push(el);
    }
    const field = this.props.names[pathChain.join('-')];
    return field ? field : pathChain[pathChain.length - 1];
  }

  getChildren(el) {
    if (el.children.length === 1 && el.children[0].tag === 'choice') {
      return el.children[0].children;
    }
    return el.children;
  }

  checkChildren(el) {
    if (!el) debugger;
    let children = el.children;

    if (children.length) {
      children = this.getChildren(el);
      if (children.length && children.every(c => c.tag === 'value')) return 'select';
      if (children.length && children.every(c => c.tag === 'text')) return 'text';
      if (children.length && children.some(c => c.tag === 'data')) return 'data';
    }

    return false;
  }

  getValues(p) {
    return (this.props.values[p] || []).slice(0);
  }

  setValue(val, dataType) {
    const values = {};

    values[this.props.path] = this.getValues(this.props.path);

    if (!values[this.props.path].length) {
      values[this.props.path] = [];
    }

    if (dataType && dataType === 'integer') {
      val = parseInt(val, 10);

      if (isNaN(val)) {
        val = null;
      }
    }

    values[this.props.path][this.props.valueIndex || 0] = val;

    this.props.setValues(values);
  }

  getValue(noPrefill) {
    const value = this.getValues(this.props.path)[this.props.valueIndex || 0];

    if (!value && !noPrefill) {
      if (this.props.prefills[this.props.path]) {
        const prefill = this.props.prefills[this.props.path];
        setTimeout(() => this.setValue(prefill));
        return prefill;
      }
    }
    
    return this.getValues(this.props.path)[this.props.valueIndex || 0];
  }

  getDefault() {
    return this.props.defaults[this.props.path];
  }

  render() {
    const struct = this.getSubStructure(this.props.structure, this.props.path);
    const childrenCheck = this.checkChildren(struct);
    const children = this.getChildren(struct);

    const isSelect = childrenCheck === 'select';
    const isText = childrenCheck === 'text';
    const dataType = childrenCheck === 'data';

    const unit = this.getUnit(this.props.path);

    const choiceType = isSelect && struct.children[0].choiceType && ('type-' + struct.children[0].choiceType);

    return (
      <div className={"element" + (struct.optional ? '' : ' mandatory')}>
        <div className="formcontrol">
          <label title={struct.name + ' - ' + this.getDescription(this.props.path)}>
            {this.getLabel(this.props.path)}
            {unit && <span className="unit">{unit}</span>}
          </label>
          {isSelect && <select
            value={this.getValue() || ''}
            required={!struct.optional}
            onInput={(e) => this.setValue(e.target.value)}>
              {children.map(el => <option key={el.value} value={el.value}>{this.getLabel(choiceType || this.props.path, el.value)}</option>)}
            </select>
          }
          {isText &&
            <input
              type="text"
              required={!struct.optional}
              placeholder={this.getDefault()}
              onInput={(e) => this.setValue(e.target.value)}
              value={this.getValue() || ''}
            />
          }
          {dataType && (children[0].type === 'date') &&
            <input
              value={this.getValue(true) || ''}
              required={!struct.optional}
              onInput={(e) => this.setValue(e.target.value, children[0].type)}
              type={this.dataTypeToText[children[0].type]}
              min="1950-01-01"
              max="2100-12-31"
            />
          }
          {dataType && (children[0].type !== 'date') &&
            <input
              value={this.getValue() || ''}
              required={!struct.optional}
              onInput={(e) => this.setValue(e.target.value, children[0].type)}
              type={this.dataTypeToText[children[0].type]}
            />
          }
        </div>
      </div>
    )
  }
}

export default Element;



// WEBPACK FOOTER //
// ./src/Element.js